import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
/* import store from "../store/index.js"; */

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "Home",
    component: Home,
    beforeEnter(to, from, next) {
      let user
      if (localStorage.getItem("token")) {
        let token = localStorage.getItem("token")
        let jwtToken = token.split(".")[1]
        user = JSON.parse(window.atob(jwtToken))
      }
      if (!user || user.length == 0 || user == undefined) {
        next("/login")
      } else {
        next()
      }
    }
  },
  {
    path: "/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ "../views/Login.vue"),
  },
  {
    path: "/jobs",
    name: "Jobs",
    component: () => import("../views/Jobs.vue"),
    beforeEnter(to, from, next) {
      let user
      if (localStorage.getItem("token")) {
        let token = localStorage.getItem("token")
        let jwtToken = token.split(".")[1]
        user = JSON.parse(window.atob(jwtToken))
      }
      if (!user || user.length == 0 || user == undefined) {
        next("/login")
      } else {
        next()
      }
    }
  },
  {
    path: "/content",
    name: "Content",
    component: () => import("../views/Content.vue"),
    beforeEnter(to, from, next) {
      let user
      if (localStorage.getItem("token")) {
        let token = localStorage.getItem("token")
        let jwtToken = token.split(".")[1]
        user = JSON.parse(window.atob(jwtToken))
      }
      if (!user || user.length == 0 || user == undefined) {
        next("/login")
      } else {
        next()
      }
    }
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/Register.vue"),
    beforeEnter(to, from, next) {
      let user
      if (localStorage.getItem("token")) {
        let token = localStorage.getItem("token")
        let jwtToken = token.split(".")[1]
        user = JSON.parse(window.atob(jwtToken))
      }
      if (!user || user.length == 0 || user == undefined) {
        next("/login")
      } else {
        next()
      }
    }
  },
  {
    path: "/skills",
    name: "skills",
    component: () => import("../views/Skills.vue"),
    beforeEnter(to, from, next) {
      let user
      if (localStorage.getItem("token")) {
        let token = localStorage.getItem("token")
        let jwtToken = token.split(".")[1]
        user = JSON.parse(window.atob(jwtToken))
      }
      if (!user || user.length == 0 || user == undefined) {
        next("/login")
      } else {
        next()
      }
    }
  },
  {
    path: "/recruitment",
    name: "recruitment",
    component: () => import("../views/Recruitment.vue"),
    beforeEnter(to, from, next) {
      let user
      if (localStorage.getItem("token")) {
        let token = localStorage.getItem("token")
        let jwtToken = token.split(".")[1]
        user = JSON.parse(window.atob(jwtToken))
      }
      if (!user || user.length == 0 || user == undefined) {
        next("/login")
      } else {
        next()
      }
    }
  },
  {
    path: "/jobs/:id/candidates",
    name: "candidates",
    component: () => import("../views/JobsCandidates.vue"),
    beforeEnter(to, from, next) {
      let user
      if (localStorage.getItem("token")) {
        let token = localStorage.getItem("token")
        let jwtToken = token.split(".")[1]
        user = JSON.parse(window.atob(jwtToken))
      }
      if (!user || user.length == 0 || user == undefined) {
        next("/login")
      } else {
        next()
      }
    }
  },
  {
    path: "/users",
    name: "users",
    component: () => import("../views/Users.vue"),
    beforeEnter(to, from, next) {
      let user
      if (localStorage.getItem("token")) {
        let token = localStorage.getItem("token")
        let jwtToken = token.split(".")[1]
        user = JSON.parse(window.atob(jwtToken))
      }
      if (!user || user.length == 0 || user == undefined) {
        next("/login")
      } else if (user.type == 0) {
        next("/")
      } else {
        next()
      }
    }
  },
  {
    path: "/applications",
    name: "applications",
    component: () => import("../views/AllCandidates.vue"),
    beforeEnter(to, from, next) {
      let user
      if (localStorage.getItem("token")) {
        let token = localStorage.getItem("token")
        let jwtToken = token.split(".")[1]
        user = JSON.parse(window.atob(jwtToken))
      }
      if (!user || user.length == 0 || user == undefined) {
        next("/login")
      } else {
        next()
      }
    }
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/Profile.vue"),
    beforeEnter(to, from, next) {
      let user
      if (localStorage.getItem("token")) {
        let token = localStorage.getItem("token")
        let jwtToken = token.split(".")[1]
        user = JSON.parse(window.atob(jwtToken))
      }
      if (!user || user.length == 0 || user == undefined) {
        next("/login")
      } else {
        next()
      }
    }
  },
  {
    path: "/website",
    name: "website",
    component: () => import("../views/Website.vue"),
    beforeEnter(to, from, next) {
      let user
      if (localStorage.getItem("token")) {
        let token = localStorage.getItem("token")
        let jwtToken = token.split(".")[1]
        user = JSON.parse(window.atob(jwtToken))
      }
      if (!user || user.length == 0 || user == undefined) {
        next("/login")
      } else {
        next()
      }
    }
  },
  {
    path: "/content/:id",
    name: "content",
    component: () => import("../views/ContentByPage.vue"),
    beforeEnter(to, from, next) {
      let user
      if (localStorage.getItem("token")) {
        let token = localStorage.getItem("token")
        let jwtToken = token.split(".")[1]
        user = JSON.parse(window.atob(jwtToken))
      }
      if (!user || user.length == 0 || user == undefined) {
        next("/login")
      } else if (user.type == 0) {
        next("/")
      } else {
        next()
      }
    }
  },
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;